import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=0bd75eea&scoped=true"
import script from "./PageView.vue?vue&type=script&lang=js"
export * from "./PageView.vue?vue&type=script&lang=js"
import style0 from "./PageView.vue?vue&type=style&index=0&id=0bd75eea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd75eea",
  null
  
)

export default component.exports